import { globalStartNotificationWebSocket } from "../websocket/globalStartNotificationWebSocket";
import { emitter } from "../mitt";
import { useUserStoreHook } from "@/store/modules/user";

/**
 * 全局开播通知和余额同步初始化器
 * 在应用启动时调用，用于设置跨浏览器同步
 */
export function initGlobalBalanceSync() {
  // 🚀 启动全局开播通知 WebSocket 连接
  globalStartNotificationWebSocket.reset();
  globalStartNotificationWebSocket
    .connect()
    .then(() => { })
    .catch(error => { });

  // 🌐 启动跨浏览器通信监听
  globalStartNotificationWebSocket.initCrossBrowserListener();

  // 💰 监听余额更新事件，同步到用户 store
  emitter.on("balanceUpdate", data => {
    try {
      const userStore = useUserStoreHook();
      if (userStore && typeof userStore.updateBalanceRealtime === "function") {
        userStore.updateBalanceRealtime(data.remainder);
      } else {
      }
    } catch (error) { }
  });

  // 🚀 监听直播状态变化事件
  emitter.on("liveStatusChange", data => {
    // 开播通知 WebSocket 会自动处理状态变化，这里主要用于日志记录
  });

  // 🏠 监听房间状态同步事件
  emitter.on("roomStatusSync", data => {
    // 房间状态同步会由各个组件自己处理
  });

  // 🎈 监听计费 WebSocket 关闭事件（跨浏览器同步）
  // 🔧 修复：添加防重复触发机制
  let isProcessingClose = false;
  emitter.on("balanceWebSocketClose", data => {
    // 🚀 防止循环触发
    if (isProcessingClose) {
      return;
    }

    isProcessingClose = true;

    // 🚀 无论什么原因，都检查并关闭本地的计费 WebSocket（如果连接着）
    try {
      // 导入并关闭全局余额 WebSocket
      import("../websocket/globalBalanceWebSocket").then(({ globalBalanceWebSocket }) => {
        if (globalBalanceWebSocket.isConnected()) {
          // 🔧 修复：使用静默关闭方法，不再触发新的事件
          (globalBalanceWebSocket as any)._silentDisconnect(
            "跨浏览器同步关闭"
          );
        }

        // 重置标志，允许下次处理
        setTimeout(() => {
          isProcessingClose = false;
        }, 1000);
      });
    } catch (error) {
      isProcessingClose = false;
    }
  });
}

/**
 * 清理全局开播通知和余额同步
 * 在应用卸载时调用
 */
export function cleanupGlobalBalanceSync() {
  // 断开 WebSocket 连接
  globalStartNotificationWebSocket.disconnect();

  // 解绑事件监听
  emitter.off("balanceUpdate");
  emitter.off("liveStatusChange");
  emitter.off("roomStatusSync");
  emitter.off("balanceWebSocketClose");
}
